import script from "./msgItem.vue?vue&type=script&setup=true&name=MsgItem&lang=js"
export * from "./msgItem.vue?vue&type=script&setup=true&name=MsgItem&lang=js"

import "./msgItem.vue?vue&type=style&index=0&id=49726b1b&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49726b1b"]])

export default __exports__